import Header from './components/header';
import Footer from './components/Footer';
import Home from './pages/Home';
import './css/styles.min.css';
import './SCSS/main.scss';

function App() {
  return (
    <>
      <Header/>
      <Home/>
      <Footer/>
    </>
  );
}

export default App;
